export default "__VITE_ASSET__7t0UMZc7__"